// Production
export const API_BASE_URL = 'https://backend.tenderwise.xyz/api/v1';
export const PHOTO_BASE_URL = 'https://backend.tenderwise.xyz/user-files/';
export const PHOTO_BASE_URL_Admin = 'https://backend.tenderwise.xyz/admin-files/';
export const SHARE_BASE_URL = 'https://tenderwise.xyz';

// Local
// export const SHARE_BASE_URL = 'http://localhost:3000';
// export const API_BASE_URL = 'http://192.168.0.229:9009/api/v1';
// export const PHOTO_BASE_URL = 'http://192.168.0.229:9009/user-files/';
// export const PHOTO_BASE_URL_Admin = 'http://192.168.0.229:9009/admin-files/';